// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__FgRSz","selects":"Documents_selects__2gaii"};